<template>
  <div class="form-container">
    <div
      v-if="permissionFilter.includes(profile.roles.name)"
      class="mb-3 d-flex justify-content-end align-items-center"
    >
      <div class="filter">
        <b-row>
          <b-col>
            <b-form-group
              label="Company"
              label-size="sm"
              content-cols-sm="8"
              label-for="input-horizontal"
              label-class="font-weight-bold"
            >
              <b-form-select
                v-model="company"
                :options="companyOptions"
                placeholder="Select Company"
                value-field="id"
                text-field="name"
                size="sm"
                @change="$refs.summaryHMTable.refresh()"
              >
                <template #first>
                  <b-form-select-option
                    :value="null"
                  >
                    All Company
                  </b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </div>
    <filters
      :filter-data.sync="filters"
      @apply="$refs.summaryHMTable.refresh()"
      @reset="resetFilter"
    />
    <div class="d-flex justify-content-between align-items-center mb-4">
      <div v-if="!visible">
        List Summary HM &amp; EWH
      </div>
      <div class="menu-selected d-flex justify-content-between" v-if="visible">
        <div class="text-selected">{{ selectedItems.length }} Selected</div>
        <b-button
          v-if="!haveApproved"
          class="btn-custom"
          variant="success"
          size="sm"
          @click="onSelectedSubmit(selectedItems)"
        >
          Submit
        </b-button>
        <b-button
          class="btn-custom ml-2"
          variant="success"
          size="sm"
          @click="onSelectedPrint(selectedItems)"
        >
          Print
        </b-button>
      </div>
      <div>
        <span>Show</span>
        <b-form-select
          v-model="perPage"
          :options="perPageOptions"
          class="page-option ml-2 mr-2 w-auto"
        />
        <span>Entries</span>
      </div>
      <b-form-group class="m-0">
        <b-form-input
          v-model="search"
          placeholder="Search..."
          @change="$refs.summaryHMTable.refresh()"
          size="sm"
        ></b-form-input>
      </b-form-group>
    </div>
    <b-table
      hover
      class="mb-4"
      table-class="table-hm"
      thead-class="table-list-header"
      empty-text="No data"
      ref="summaryHMTable"
      :items="fetchSummaryHM"
      :fields="fields"
      :per-page="perPage"
      :current-page="currentPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :busy="isBusy"
      @row-clicked="goDetail"
      sort-icon-left
      show-empty
      responsive
    >
      <template v-slot:cell(selected)="items">
        <div class="h-100 py-2 px-3" @click.stop>
          <b-form-checkbox
            v-if="canAdd || canPrint"
            @input="onPreviewClick($event, items.item)"
            size="lg"
          />
        </div>
      </template>
      <template v-slot:cell(Action)="items" v-if="canPrint || canAdd">
        <div>
          <b-dropdown
            toggle-class="text-dark p-0"
            menu-class="shadow border-0"
            variant="link"
            right
            no-caret
          >
            <template v-slot:button-content>
              <fa-icon class="text-info" icon="ellipsis-v" />
            </template>
            <b-dropdown-item
              v-if="canPrint"
              @click="onPrint(items.item)"
            >
              Print
            </b-dropdown-item>
            <b-dropdown-item
              v-if="canAdd && (items.item.status === 'Draft' || items.item.status === 'Revise')"
              @click="onRowSubmit(items.item)"
            >
              Submit
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>
      <template v-slot:table-busy>
        <div class="text-center my-4">
          <b-spinner variant="info" class="spinner-lg" />
        </div>
      </template>
      <template #cell()="{ value, item }">
        <a
          class="d-block h-100 text-dark"
          :href="`/summary-hm-ewh/detail?${item.hm_id ? `hm_id=${item.hm_id}` : `wo_id=${item.wo_id}&unit_id=${item.unit_id}`}`"
        >
          {{ value }}
        </a>
      </template>
      <template #cell(status)="items">
        <div :class="statusChange(items.item.status)">{{ items.item.status }}</div>
      </template>
      <template #cell(waiting_approval)="items">
        <ul v-if="items.item.status.toLowerCase().includes('waiting approval')">
          <li
            v-for="(n, i) in items.item.waiting_approval.split(',')"
            :key="i"
          >
            {{
              n
            }}
          </li>
        </ul>
      </template>
    </b-table>
    <div class="d-flex justify-content-end align-items-center">
      <span class="show-entries mr-auto ml-4">
        {{`Show ${totalRows === 0 ? 0 : ((currentPage-1) * perPage) + 1} to ${totalRows > ((currentPage) * perPage) ? ((currentPage) * perPage) : totalRows} of ${totalRows} entries`}}
      </span>
      <b-pagination
        v-model="currentPage"
        :per-page="perPage"
        :total-rows="totalRows"
        pills
        hide-goto-end-buttons
      />
    </div>
  </div>
</template>

<script>
import api from '@/api'
import Filters from './Filter'
import { hasPermission } from '@/utils/permissions'
import { HM_EWH_ADD, HM_EWH_PRINT } from '@/fixtures'

export default {
  components: {
    Filters
  },

  data: () => ({
    profile: JSON.parse(localStorage.getItem('profile')),
    canAdd: hasPermission(HM_EWH_ADD),
    canPrint: hasPermission(HM_EWH_PRINT),
    visible: false,
    isBusy: false,
    search: '',
    currentPage: localStorage.getItem('currentPage') ?? 1,
    perPage: 10,
    totalRows: localStorage.getItem('totalRows') ?? 0,
    sortBy: 'contractor_name',
    sortDesc: false,
    fields: [
      { key: 'selected', label: '', sortable: false, thClass: 'start', tdClass: 'p-0' },
      { key: 'Action', sortable: false },
      { key: 'contractor_name', label: 'Contractor Name', sortable: true },
      { key: 'contract_number', label: 'Contract Number', sortable: true },
      { key: 'wo_number', label: 'WO Number', sortable: true },
      { key: 'unit_name', label: 'Unit ID', sortable: true },
      { key: 'department', label: 'Department', sortable: true },
      { key: 'job_desc', label: 'Job Desc', sortable: true, thStyle: 'width: 200px' },
      { key: 'budget_code', label: 'Budget Code', sortable: true, thStyle: 'width: 150px' },
      { key: 'status', label: 'Status', sortable: true, thStyle: 'width: 150px' },
      { key: 'waiting_approval', label: 'Waiting Approval', thStyle: 'width: 150px', thClass: 'end' }
    ],
    items: [],
    perPageOptions: [
      { value: 10, text: '10' },
      { value: 20, text: '20' },
      { value: 30, text: '30' }
    ],
    valueOptions: [],
    filters: !localStorage.getItem('filterSummaryHM') ? {
      contractor_name: '',
      contract_number: '',
      wo_number: '',
      department: '',
      job_desc: '',
      budget_code: '',
      status: ''
    } : JSON.parse(localStorage.getItem('filterSummaryHM')),
    selectedItems: [],
    haveApproved: false,
    company: null,
    companyOptions: [],
    permissionFilter: [
      'Super Admin',
      'Finance Jakarta',
      'Administrator'
    ]
  }),

  computed: {
    stringifiedFilters() {
      const str = Object.entries(this.filters).filter(v => v[1]).map(v => v.join(':')).join()
      return str
    }
  },

  mounted() {
    this.fetchCompany()
  },

  methods: {
    async fetchSummaryHM() {
      const data = await api.summaryHM.list({
        sort_by: this.sortBy,
        sort_dir: this.sortDesc ? 'desc' : 'asc',
        page: this.currentPage,
        limit: this.perPage,
        search: this.search,
        company_id: this.company,
        filter_value: this.stringifiedFilters
      })
      this.totalRows = data ? data.count : 100
      this.items = data ? data.rows : []
      this.items.map(d => {
        if (!d.has_summary && d.status === 'Approved') {
          d._rowVariant = 'success'
        }
      })

      localStorage.removeItem('currentPage')
      localStorage.removeItem('totalRows')

      localStorage.setItem('filterSummaryHM', JSON.stringify(this.filters))

      this.selectedItems = this.$options.data().selectedItems
      this.visible = false

      return this.items
    },
    resetFilter() {
      this.filters = {
        contractor_name: '',
        contract_number: '',
        wo_number: '',
        department: '',
        job_desc: '',
        budget_code: '',
        status: ''
      }
      this.currentPage = 1
      localStorage.removeItem('filterSummaryHM')
      this.$refs.summaryHMTable.refresh()
    },
    async fetchCompany() {
      try {
        this.companyOptions = await api.company.list_active()
      } catch ({ response }) {
        this.error = response.data.message
      }
    },
    goDetail(item) {
      localStorage.setItem('currentPage', this.currentPage)
      localStorage.setItem('totalRows', this.totalRows)
      this.$router.push({ path: `/summary-hm-ewh/detail?${item.hm_id ? `hm_id=${item.hm_id}` : `wo_id=${item.wo_id}&unit_id=${item.unit_id}`}` })
    },
    onPreviewClick(value, item) {
      if (value) {
        this.selectedItems.push(item)
        this.haveApproved = this.selectedItems.find(d => d.status === 'Approved')
      } else {
        if (this.selectedItems.length !== 1) {
          const index = this.selectedItems.findIndex(d => d.id === item.id)
          this.selectedItems = [
            ...this.selectedItems.slice(0, index),
            ...this.selectedItems.slice(index + 1)
          ]
          this.haveApproved = this.selectedItems.some(d => d.status === 'Approved')
        } else {
          this.selectedItems = []
        }
      }
      this.visible = this.selectedItems.length !== 0
    },
    async onSelectedPrint(item) {
      item.forEach(d => {
        this.onPrint(d)
      })
    },
    async onSelectedSubmit(item) {
      item.forEach(d => {
        this.onRowSubmit(d)
      })
      this.$refs.summaryHMTable.refresh()
    },
    async onPrint(item) {
      const url = `${process.env.VUE_APP_PRINT_URL}/SummaryHMEWH?WoId=${item.wo_id}&UnitId=${item.unit_id}&Id=${item.hm_id ?? 0}`
      window.open(url)
    },
    async onRowSubmit(item) {
      try {
        this.detail.HmEwhTable.map(d => {
          if (d.status === 'Approved' && !d.is_reference) {
            d.check = true
          }
        })
        const ids = item.HmEwhTable.filter(d => d.check).map(d => d.id)
        await api.summaryHM.submit({
          is_submit: true,
          is_draft: false,
          logsheet_id: ids,
          wo_id: item.wo_id,
          unit_id: item.unit_id,
          company_id: item.company_id
        })
        this.$bvModal.show('modal-successful')
      } catch ({ response }) {
        this.$nextTick(() => {
          this.$bvToast.toast(`${response.status} ${response.data.error.message}`, {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }
    },
    onRowDelete(value) {
      this.deleteItem = value
      this.$bvModal.show('modal-delete')
    },
    statusChange(status) {
      if (status === 'Draft') {
        return 'draft'
      } else if (status === 'Approved') {
        return 'approved'
      } else if (status === 'Revise') {
        return 'revised'
      } else if (status === 'Waiting Approval') {
        return 'waiting-approval'
      } else {
        return 'waiting-approval'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  width: 100%;
}
.text-selected {
  margin-right: 10px;
  font-size: 18px;
  font-weight: 600;
  margin-top: 2px;
}
</style>
